import React, { useState,useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import { useParams } from "react-router-dom";
import { API_URL } from "..";
import QuoteEditLayer from "../components/QuoteEditLayer";




const QuoteEditPage = () => {
  const {id}= useParams();

  const [data, setData] = useState({})

  const fetchSingle = async()=>{
    const user = JSON.parse(localStorage.getItem('user'))
      
      let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let response = await fetch(API_URL+`/api/invoice/${id}/`, { 
         method: "GET",
         headers: headersList
       });
       const data = await response.json();
       if(response.status ===200){
         setData(data)
        }else{
         setData([])

       }
     }

     useEffect(()=>{
      fetchSingle()
     },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Quote - Edit" />

        {/* InvoiceEditLayer */}
        {
          data?.invoice_number  === undefined  ? null :
        <QuoteEditLayer invoiceData={data}  invoiceID={id}/>
        }

      </MasterLayout>

    </>
  );
};

export default QuoteEditPage;
